<ng-container [formGroup]="controlGroup" class="hup-subscription-address-specifics">
  @if (controlGroup.get('address.country')?.value?.key !== 'A' && controlGroup.get('address.country')?.value !== 'A') {
    <ng-container formGroupName="address" class="hup-subscription-address-specifics__address">
      <div class="row">
        <mat-form-field class="col-12 col-md-6 --ps-2 hup-subscription-address-specifics__field">
          <mat-label class="hup-subscription-address-specifics__label"
                     [innerHTML]="translationService.getTranslation('address_street')"></mat-label>
          <input matInput formControlName="street" [required]="isRequired(AddressFormularField.STREET)"
                 [matAutocomplete]="matStreetNames"
                 (focusin)="searchAddressEmit.emit()" data-cy="input-street"
                 class="hup-subscription-address-specifics__input">
          <mat-autocomplete #matStreetNames="matAutocomplete" class="hup-subscription-address-specifics__autocomplete">
            @for (street of streetNames; track street) {
              <mat-option [value]="street" class="hup-subscription-address-specifics__option">
                {{ street }}
              </mat-option>
            }
          </mat-autocomplete>
          @if (controlGroup.get('address.street').hasError('message')) {
            <mat-error class="hup-subscription-address-specifics__error"
            >{{ controlGroup.get('address.street').getError('message') }}
            </mat-error>
          }
        </mat-form-field>
        <mat-form-field class="col-12 col-md-6 --ps-2 hup-subscription-address-specifics__field">
          <mat-label class="hup-subscription-address-specifics__label"
                     [innerHTML]="translationService.getTranslation('address_houseno')"></mat-label>
          <input maxlength="10" matInput formControlName="houseNo"
                 (keyup)="replaceInvalidCharactersFromHouseNo(); searchAddressEmit.emit();"
                 [required]="isRequired(AddressFormularField.HOUSE_NUMBER)"
                 #houseNumber data-cy="input-house-no" class="hup-subscription-address-specifics__input">
          @if (houseNumber === document?.activeElement && houseNumber.value.length >= 1) {
            <mat-hint align="end" class="hup-subscription-address-specifics__hint">{{ houseNumber.value.length }}
              / {{ houseNumber.maxLength }}
            </mat-hint>
          }
          @if (controlGroup.get('address.houseNo').hasError('message')) {
            <mat-error class="hup-subscription-address-specifics__error"
            >{{ controlGroup.get('address.houseNo').getError('message') }}
            </mat-error>
          }
        </mat-form-field>
      </div>
    </ng-container>
  }

  @if (controlGroup.get('address.country').value === 'A' || controlGroup.get('address.country').value.key === 'A') {
    <ng-container formGroupName="address" class="hup-subscription-address-specifics__address">
      <mat-form-field class="col-12 col-md-6 ps-2 hup-subscription-address-specifics__field">
        <mat-label class="hup-subscription-address-specifics__label"
                   [innerHTML]="translationService.getTranslation('address_street')"></mat-label>
        <input matInput formControlName="street" [required]="isRequired(AddressFormularField.STREET)"
               [matAutocomplete]="matStreetNames" (focusin)="searchAddressEmit.emit()" data-cy="input-street"
               class="hup-subscription-address-specifics__input">
        <mat-autocomplete #matStreetNames="matAutocomplete" class="hup-subscription-address-specifics__autocomplete">
          @for (street of streetNames; track street) {
            <mat-option [value]="street" class="hup-subscription-address-specifics__option">
              {{ street }}
            </mat-option>
          }
        </mat-autocomplete>
        @if (controlGroup.get('address.street').hasError('message')) {
          <mat-error class="hup-subscription-address-specifics__error"
          >{{ controlGroup.get('address.street').getError('message') }}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="col-3 ps-2 hup-subscription-address-specifics__field">
        <mat-label class="hup-subscription-address-specifics__label"
                   [innerHTML]="translationService.getTranslation('address_houseno')"></mat-label>
        <input maxLength="10" matInput formControlName="houseNo" (keyup)="replaceInvalidCharactersFromHouseNo()"
               [required]="isRequired(AddressFormularField.HOUSE_NUMBER)"
               #houseNumber data-cy="input-house-no" class="hup-subscription-address-specifics__input">
        @if (houseNumber === document?.activeElement && houseNumber.value.length >= 1) {
          <mat-hint align="end" class="hup-subscription-address-specifics__hint">{{ houseNumber.value.length }}
            / {{ houseNumber.maxLength }}
          </mat-hint>
        }
        @if (controlGroup.get('address.houseNo').hasError('message')) {
          <mat-error class="hup-subscription-address-specifics__error"
          >{{ controlGroup.get('address.houseNo').getError('message') }}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="col-3 ps-2 hup-subscription-address-specifics__field">
        <mat-label class="hup-subscription-address-specifics__label"
                   [innerHTML]="translationService.getTranslation('address_stiege')"></mat-label>
        <input maxLength="2" matInput formControlName="stiege" #stiege
               class="hup-subscription-address-specifics__input">
        @if (stiege === document?.activeElement && stiege.value.length >= 1) {
          <mat-hint align="end" class="hup-subscription-address-specifics__hint">{{ stiege.value.length }}
            / {{ stiege.maxLength }}
          </mat-hint>
        }
        @if (controlGroup.get('address.stiege').hasError('message')) {
          <mat-error class="hup-subscription-address-specifics__error"
          >{{ controlGroup.get('address.stiege').getError('message') }}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="col-3 ps-2 hup-subscription-address-specifics__field">
        <mat-label class="hup-subscription-address-specifics__label"
                   [innerHTML]="translationService.getTranslation('address_stock')"></mat-label>
        <input maxLength="2" matInput formControlName="stock" #stock class="hup-subscription-address-specifics__input">
        @if (stock === document?.activeElement && stock.value.length >= 1) {
          <mat-hint align="end" class="hup-subscription-address-specifics__hint">{{ stock.value.length }}
            / {{ stock.maxLength }}
          </mat-hint>
        }
        @if (controlGroup.get('address.stock').hasError('message')) {
          <mat-error class="hup-subscription-address-specifics__error"
          >{{ controlGroup.get('stock').getError('message') }}
          </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="col-3 ps-2 hup-subscription-address-specifics__field">
        <mat-label class="hup-subscription-address-specifics__label"
                   [innerHTML]="translationService.getTranslation('address_tuer')"></mat-label>
        <input maxLength="3" matInput formControlName="tuer" #door class="hup-subscription-address-specifics__input">
        @if (door === document?.activeElement && door.value.length >= 1) {
          <mat-hint align="end" class="hup-subscription-address-specifics__hint">{{ door.value.length }}
            / {{ door.maxLength }}
          </mat-hint>
        }
        @if (controlGroup.get('address.tuer').hasError('message')) {
          <mat-error class="hup-subscription-address-specifics__error"
          >{{ controlGroup.get('address.tuer').getError('message') }}
          </mat-error>
        }
      </mat-form-field>
    </ng-container>
  }
</ng-container>
